import { render } from "./clients-header.vue?vue&type=template&id=9b483802"
import script from "./clients-header.vue?vue&type=script&lang=js"
export * from "./clients-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__